import React from "react";
import Leaderboard from "../components/Leaderboard";
import "../styling/leaderboard.css";

export default function LeaderboardPage() {
  return (
    <div className="leaderboard-page">
      <Leaderboard />
    </div>
  );
}
